import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, useNavigate } from 'react-router-dom';
import { deleteUser, getUsers } from '../../api/webServices';
import { deleteUserAction, setActualUser, setUsersList } from '../../store/reducers/usersSlice';
import ItemsTable from '../ItemsTable';
import { getPermissions } from '../../utils/various';

const Users = () => {
    const { usersList } = useSelector(state => state.users);
    const { sessionData } = useSelector(state => state.session);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        const permissions = getPermissions(sessionData?.role);
        if (!permissions.admin) {
            return <Navigate to={'/'} replace={true} />
        }
        //Cargar usuarios
        getUsers().then(res => dispatch(setUsersList(res?.data)));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleAddUser = () => {
        navigate('/user');
    }

    const handleEditUser = (username) => {
        let user = usersList.find(user => user.username === username);
        dispatch(setActualUser(user));
        navigate('/user');
    }

    const handleDeleteUser = (username) => {
        deleteUser({ username }).then(res => {
            dispatch(deleteUserAction(username));
        }).catch(err => {
            console.log(err);
        }
        );
    }

    return (
        <div className="flex flex-col items-center justify-center w-full h-full gap-20">
            <div className="w-[85%] bg-white h-[90%] my-auto rounded-2xl">
                <h2 className="2xl:py-8 2xl:leading-[75px] text-[30px] 2xl:text-[40px] mt-7 titleRequests">Usuarios</h2>
                <div className="2xl:w-[65%] w-[80%] mx-auto mt-10">
                    <div className="flex flex-row items-center gap-3">
                        <button className="mx-5 newRequestButton" onClick={handleAddUser}>+ Crear usuario</button>
                    </div>
                    <ItemsTable
                        type="users"
                        data={usersList}
                        handleEdit={handleEditUser}
                        handleDelete={handleDeleteUser}
                    />
                </div>
            </div>
        </div>
    )
}

export default Users